/**
 * "12.00"-style price, or "—" when there is none. Offers can come back without a price:
 * GET /seller-offer/marketplace strips buyerPrice for any user whose type isn't "buyer".
 */
export const formatPrice = (price: unknown): string => {
    if (price === null || price === undefined || price === '') return '—';
    const value = Number(price);
    return Number.isFinite(value) ? value.toFixed(2) : '—';
};
